import { render, staticRenderFns } from "./StepNotEligibleMMR.vue?vue&type=template&id=1a2b0e54&"
import script from "./StepNotEligibleMMR.vue?vue&type=script&lang=js&"
export * from "./StepNotEligibleMMR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports